import { GET_THREAT_LANDSCAPE } from "../types/threatLandscapeType";

const initialState = {
  threatLandscape: [],
  loading: false,
  error: null,
};

const threatLandscapeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_THREAT_LANDSCAPE:
      return {
        ...state,
        threatLandscape: action.payload,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default threatLandscapeReducer;
